import {useMutation, useQuery} from 'react-query';

import {queryClient} from 'client/common/utils/react-query';
import {addOrgUser, removeOrgUser, OrgUser, getOrgUsers} from 'client/common/utils/api-client';

import {getOrgUsersKey} from '.';

export function useOrgUsers(orgId: number) {
    return useQuery(getOrgUsersKey(orgId), async () => {
        const {data} = await getOrgUsers(orgId);

        return data.users ?? [];
    });
}

export function useOrgAddUser(orgId: number) {
    const key = getOrgUsersKey(orgId);

    const {mutateAsync} = useMutation(addOrgUser, {
        onMutate: async () => {
            await queryClient.cancelQueries(key);
        },
        onSettled: () => {
            queryClient.refetchQueries(key);
        }
    });

    return async (login: string) => {
        await mutateAsync({orgId, login});
    };
}

export function useOrgRemoveUser(orgId: number) {
    const key = getOrgUsersKey(orgId);

    const {mutateAsync} = useMutation(removeOrgUser, {
        onMutate: async ({login}) => {
            await queryClient.cancelQueries(key);

            queryClient.setQueryData(key, (old: OrgUser[]) =>
                old.filter(user => user.login !== login)
            );
        },
        onSettled: () => {
            queryClient.refetchQueries(key);
        }
    });

    return async (login: string) => {
        await mutateAsync({orgId, login});
    };
}
